import { useEffect, useState } from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Services from './components/Services';
import Workshops from './components/Workshops';
import About from './components/About';
import ServiceAreas from './components/ServiceAreas';
import Contact from './components/Contact';
import InnerFooter from '../../components/feature/InnerFooter';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);

    // SEO Meta Tags
    document.title = 'Evernorth AI | AI Training & Consulting | Northwest Georgia';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Evernorth AI provides practical AI training workshops and consulting for businesses in Northwest Georgia. Learn to use AI confidently with hands-on education in Rome, Calhoun, Dalton, and surrounding areas.');
    }

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL}/`);
    }

    // Schema.org JSON-LD
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Evernorth AI",
      "description": "AI training workshops and consulting services for businesses in Northwest Georgia",
      "url": `${import.meta.env.VITE_SITE_URL}/`,
      "telephone": "+1-706-331-5858",
      "email": "info@evernorthai.com",
      "address": {
        "@type": "PostalAddress",
        "addressRegion": "GA",
        "addressCountry": "US"
      },
      "areaServed": [
        {
          "@type": "City",
          "name": "Rome",
          "containedInPlace": {
            "@type": "State",
            "name": "Georgia"
          }
        },
        {
          "@type": "City",
          "name": "Calhoun",
          "containedInPlace": {
            "@type": "State",
            "name": "Georgia"
          }
        },
        {
          "@type": "City",
          "name": "Dalton",
          "containedInPlace": {
            "@type": "State",
            "name": "Georgia"
          }
        },
        {
          "@type": "City",
          "name": "Cartersville",
          "containedInPlace": {
            "@type": "State",
            "name": "Georgia"
          }
        },
        {
          "@type": "City",
          "name": "Jasper",
          "containedInPlace": {
            "@type": "State",
            "name": "Georgia"
          }
        },
        {
          "@type": "City",
          "name": "Ellijay",
          "containedInPlace": {
            "@type": "State",
            "name": "Georgia"
          }
        },
        {
          "@type": "City",
          "name": "Ringgold",
          "containedInPlace": {
            "@type": "State",
            "name": "Georgia"
          }
        },
        {
          "@type": "City",
          "name": "Kennesaw",
          "containedInPlace": {
            "@type": "State",
            "name": "Georgia"
          }
        }
      ],
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "09:00",
          "closes": "17:00"
        }
      ],
      "priceRange": "$$",
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "AI Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Half Day AI Workshop",
              "description": "3.5 hours of practical AI training"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Full Day AI Workshop",
              "description": "7 hours of comprehensive AI training"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "AI Readiness Audit",
              "description": "Assessment and strategy consultation"
            }
          }
        ]
      }
    });
    document.head.appendChild(schemaScript);

    return () => {
      document.head.removeChild(schemaScript);
    };
  }, []);

  return (
    <>
      <Navigation scrolled={scrolled} />
      <Hero />
      <Services />
      <Workshops />
      <About />
      <ServiceAreas />
      <Contact />
      <InnerFooter />
    </>
  );
}